export * from './intervention.component';
